module.exports = {
  API_ROOT: 'https://racingmax2023.backend.pre.next-insur.tech'
}
